/**
 * Dmon RGS Provider Configuration — Midnight Alchemy on the NobleFruits math.
 *
 * Same API structure as PopiPlay. Server symbols are 1-indexed strings
 * ("1".."11"); the game is 0-indexed.
 */

const MAX_MULTIPLIER = window.__OPTIONS__?.math?.max_multiplier || 5000;

export const PROVIDER_CONFIG = {
  PROVIDER_NAME: "Dmon",

  SYMBOL_MAP: {
    1: 0,   // wild
    2: 1,   // hp1
    3: 2,   // mp2
    4: 3,   // mp3
    5: 4,   // mp1
    6: 5,   // lp1
    7: 6,   // lp2
    8: 7,   // lp3
    9: 8,   // lp4
    10: 9,  // sc1
    11: 10, // sc2
  },

  WILD_SYMBOL_ID: 0,

  SCATTER_SYMBOL_IDS: [9, 10],

  // No free spins and no Hold & Win on this math.
  FREE_SPINS_TRIGGER: null,
  HOLD_AND_WIN_TRIGGER: null,

  WIN_THRESHOLDS: {
    BIG_WIN_THRESHOLD: 15,
    MEGA_WIN_THRESHOLD: 50,
    SUPER_MEGA_WIN_THRESHOLD: 100,
    MAX_WIN_THRESHOLD: MAX_MULTIPLIER,
  },

  MAX_WIN_MULTIPLIER: MAX_MULTIPLIER,

  WIN_TYPES: {
    REGULAR_WIN: "regular_win",
    BIG_WIN: "big_win",
    MEGA_WIN: "mega_win",
    // Must match the SPINE SKIN name exactly — "supermega_win", one word.
    SUPER_MEGA_WIN: "supermega_win",
    MAX_WIN: "max_win",
  },

  ANIMATED_WIN_TYPES: [
    "big_win",
    "mega_win",
    "supermega_win",
    "max_win",
  ],

  // WarningPopup uses the normalized code as its translation key.
  ERROR_CODES: {
    101: 101, // player_unauthenticated
    102: 102, // player_disabled
    103: 103, // ip_not_allowed
    104: 104, // game_locked
    105: 105, // request_timeout
    201: 201, // unknown_action
    202: 202, // unavailable_action
    203: 203, // invalid_options
    204: 204, // unknown_exception
    205: 205, // free_rounds_available
    206: 206, // free_rounds_ended
    301: 301, // not_enough_money
    302: 302, // player_limit_exceeded
    303: 303, // max_bet_exceeded
    401: 401, // exceed_bet_limits
    600: 600, // not_synced_game
    700: 700, // message (reality check)
    1001: 301, // not_enough_money
    1002: 401, // invalid_bet
    1003: 101, // invalid_session
    1004: 204, // invalid_command
    1005: 204, // no_active_round
    1006: 204, // game_not_found
    1007: 204, // server_error
  },
};
